import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { usePermissions } from '../components/PermissionsContext';

const ProtectedRoute = ({ roles: requiredRoles = [], element }) => {
  const { loading, roles: userRoles = [], isSystemAdmin } = usePermissions();

  if (loading) {
    return (
      <Box sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  const allowed = isSystemAdmin || requiredRoles.length === 0 || requiredRoles.some(r => userRoles?.includes(r));
  if (!allowed) {
    return <Navigate to="/403" replace />;
  }

  return element;
};

export default ProtectedRoute;

